/**
 * Generated by orval v7.17.0 🍺
 * Do not edit manually.
 * NEXMAIL (Internal)
 * Internal API consumed by the nexmail dashboard.
 * OpenAPI spec version: 0.0.1
 */
import { useMutation, useQuery } from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
} from '@tanstack/react-query';

import type {
  BrandExtractionStreamEventDto,
  BrandReviewResponseDto,
  BrandsControllerUploadBrandFontBody,
  CreateBrandColorDto,
  CreateBrandColorResponseDto,
  CreateBrandFontDto,
  CreateBrandFontResponseDto,
  CreateBrandNavLinkDto,
  CreateBrandNavLinkResponseDto,
  CreateBrandProfileDto,
  CreateBrandProfileResponseDto,
  CreatePageImportsDto,
  CreatePageImportsResponseDto,
  DeleteBrandColorResponseDto,
  DeleteBrandFontResponseDto,
  DeleteBrandNavLinkResponseDto,
  DeleteBrandProfileResponseDto,
  DeletePageImportResponseDto,
  GetBrandProfileResponseDto,
  PageImportListResponseDto,
  ReorderBrandNavLinksDto,
  ReorderBrandNavLinksResponseDto,
  UpdateBrandColorDto,
  UpdateBrandColorResponseDto,
  UpdateBrandFontDto,
  UpdateBrandFontResponseDto,
  UpdateBrandNavLinkDto,
  UpdateBrandNavLinkResponseDto,
  UpdateBrandProfileDto,
  UpdateBrandProfileResponseDto,
} from '.././models';

import { authFetch } from '../../../../lib/api';

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];

/**
 * Retrieve the single brand profile for the specified client (one client = one profile)
 * @summary Get the brand profile for a client
 */
export const brandsControllerGetClientBrandProfile = (
  orgId: string,
  clientId: string,
  options?: SecondParameter<typeof authFetch>,
  signal?: AbortSignal
) => {
  return authFetch<GetBrandProfileResponseDto>(
    {
      url: `/api/v1/organizations/${orgId}/clients/${clientId}/brands/profile`,
      method: 'GET',
      signal,
    },
    options
  );
};

export const getBrandsControllerGetClientBrandProfileQueryKey = (
  orgId?: string,
  clientId?: string
) => {
  return [`/api/v1/organizations/${orgId}/clients/${clientId}/brands/profile`] as const;
};

export const getBrandsControllerGetClientBrandProfileQueryOptions = <
  TData = Awaited<ReturnType<typeof brandsControllerGetClientBrandProfile>>,
  TError = unknown,
>(
  orgId: string,
  clientId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof brandsControllerGetClientBrandProfile>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof authFetch>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getBrandsControllerGetClientBrandProfileQueryKey(orgId, clientId);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof brandsControllerGetClientBrandProfile>>
  > = ({ signal }) =>
    brandsControllerGetClientBrandProfile(orgId, clientId, requestOptions, signal);

  return { queryKey, queryFn, enabled: !!(orgId && clientId), ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof brandsControllerGetClientBrandProfile>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type BrandsControllerGetClientBrandProfileQueryResult = NonNullable<
  Awaited<ReturnType<typeof brandsControllerGetClientBrandProfile>>
>;
export type BrandsControllerGetClientBrandProfileQueryError = unknown;

export function useBrandsControllerGetClientBrandProfile<
  TData = Awaited<ReturnType<typeof brandsControllerGetClientBrandProfile>>,
  TError = unknown,
>(
  orgId: string,
  clientId: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof brandsControllerGetClientBrandProfile>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof brandsControllerGetClientBrandProfile>>,
          TError,
          Awaited<ReturnType<typeof brandsControllerGetClientBrandProfile>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof authFetch>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useBrandsControllerGetClientBrandProfile<
  TData = Awaited<ReturnType<typeof brandsControllerGetClientBrandProfile>>,
  TError = unknown,
>(
  orgId: string,
  clientId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof brandsControllerGetClientBrandProfile>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof brandsControllerGetClientBrandProfile>>,
          TError,
          Awaited<ReturnType<typeof brandsControllerGetClientBrandProfile>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof authFetch>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useBrandsControllerGetClientBrandProfile<
  TData = Awaited<ReturnType<typeof brandsControllerGetClientBrandProfile>>,
  TError = unknown,
>(
  orgId: string,
  clientId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof brandsControllerGetClientBrandProfile>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof authFetch>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Get the brand profile for a client
 */

export function useBrandsControllerGetClientBrandProfile<
  TData = Awaited<ReturnType<typeof brandsControllerGetClientBrandProfile>>,
  TError = unknown,
>(
  orgId: string,
  clientId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof brandsControllerGetClientBrandProfile>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof authFetch>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getBrandsControllerGetClientBrandProfileQueryOptions(
    orgId,
    clientId,
    options
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Retrieve a specific brand profile by ID
 * @summary Get specific brand profile
 */
export const brandsControllerGetBrandProfile = (
  orgId: string,
  clientId: string,
  id: string,
  options?: SecondParameter<typeof authFetch>,
  signal?: AbortSignal
) => {
  return authFetch<GetBrandProfileResponseDto>(
    {
      url: `/api/v1/organizations/${orgId}/clients/${clientId}/brands/profiles/${id}`,
      method: 'GET',
      signal,
    },
    options
  );
};

export const getBrandsControllerGetBrandProfileQueryKey = (
  orgId?: string,
  clientId?: string,
  id?: string
) => {
  return [`/api/v1/organizations/${orgId}/clients/${clientId}/brands/profiles/${id}`] as const;
};

export const getBrandsControllerGetBrandProfileQueryOptions = <
  TData = Awaited<ReturnType<typeof brandsControllerGetBrandProfile>>,
  TError = void,
>(
  orgId: string,
  clientId: string,
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof brandsControllerGetBrandProfile>>, TError, TData>
    >;
    request?: SecondParameter<typeof authFetch>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getBrandsControllerGetBrandProfileQueryKey(orgId, clientId, id);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof brandsControllerGetBrandProfile>>> = ({
    signal,
  }) => brandsControllerGetBrandProfile(orgId, clientId, id, requestOptions, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!(orgId && clientId && id),
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof brandsControllerGetBrandProfile>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type BrandsControllerGetBrandProfileQueryResult = NonNullable<
  Awaited<ReturnType<typeof brandsControllerGetBrandProfile>>
>;
export type BrandsControllerGetBrandProfileQueryError = void;

export function useBrandsControllerGetBrandProfile<
  TData = Awaited<ReturnType<typeof brandsControllerGetBrandProfile>>,
  TError = void,
>(
  orgId: string,
  clientId: string,
  id: string,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof brandsControllerGetBrandProfile>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof brandsControllerGetBrandProfile>>,
          TError,
          Awaited<ReturnType<typeof brandsControllerGetBrandProfile>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof authFetch>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useBrandsControllerGetBrandProfile<
  TData = Awaited<ReturnType<typeof brandsControllerGetBrandProfile>>,
  TError = void,
>(
  orgId: string,
  clientId: string,
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof brandsControllerGetBrandProfile>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof brandsControllerGetBrandProfile>>,
          TError,
          Awaited<ReturnType<typeof brandsControllerGetBrandProfile>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof authFetch>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useBrandsControllerGetBrandProfile<
  TData = Awaited<ReturnType<typeof brandsControllerGetBrandProfile>>,
  TError = void,
>(
  orgId: string,
  clientId: string,
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof brandsControllerGetBrandProfile>>, TError, TData>
    >;
    request?: SecondParameter<typeof authFetch>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Get specific brand profile
 */

export function useBrandsControllerGetBrandProfile<
  TData = Awaited<ReturnType<typeof brandsControllerGetBrandProfile>>,
  TError = void,
>(
  orgId: string,
  clientId: string,
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof brandsControllerGetBrandProfile>>, TError, TData>
    >;
    request?: SecondParameter<typeof authFetch>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getBrandsControllerGetBrandProfileQueryOptions(orgId, clientId, id, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Update an existing brand profile with new configuration
 * @summary Update brand profile
 */
export const brandsControllerUpdateBrandProfile = (
  orgId: string,
  clientId: string,
  id: string,
  updateBrandProfileDto: UpdateBrandProfileDto,
  options?: SecondParameter<typeof authFetch>
) => {
  return authFetch<UpdateBrandProfileResponseDto>(
    {
      url: `/api/v1/organizations/${orgId}/clients/${clientId}/brands/profiles/${id}`,
      method: 'PUT',
      headers: { 'Content-Type': 'application/json' },
      data: updateBrandProfileDto,
    },
    options
  );
};

export const getBrandsControllerUpdateBrandProfileMutationOptions = <
  TError = void,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof brandsControllerUpdateBrandProfile>>,
    TError,
    { orgId: string; clientId: string; id: string; data: UpdateBrandProfileDto },
    TContext
  >;
  request?: SecondParameter<typeof authFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof brandsControllerUpdateBrandProfile>>,
  TError,
  { orgId: string; clientId: string; id: string; data: UpdateBrandProfileDto },
  TContext
> => {
  const mutationKey = ['brandsControllerUpdateBrandProfile'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof brandsControllerUpdateBrandProfile>>,
    { orgId: string; clientId: string; id: string; data: UpdateBrandProfileDto }
  > = (props) => {
    const { orgId, clientId, id, data } = props ?? {};

    return brandsControllerUpdateBrandProfile(orgId, clientId, id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type BrandsControllerUpdateBrandProfileMutationResult = NonNullable<
  Awaited<ReturnType<typeof brandsControllerUpdateBrandProfile>>
>;
export type BrandsControllerUpdateBrandProfileMutationBody = UpdateBrandProfileDto;
export type BrandsControllerUpdateBrandProfileMutationError = void;

/**
 * @summary Update brand profile
 */
export const useBrandsControllerUpdateBrandProfile = <TError = void, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof brandsControllerUpdateBrandProfile>>,
      TError,
      { orgId: string; clientId: string; id: string; data: UpdateBrandProfileDto },
      TContext
    >;
    request?: SecondParameter<typeof authFetch>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof brandsControllerUpdateBrandProfile>>,
  TError,
  { orgId: string; clientId: string; id: string; data: UpdateBrandProfileDto },
  TContext
> => {
  const mutationOptions = getBrandsControllerUpdateBrandProfileMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * Soft delete a brand profile (marks as archived)
 * @summary Delete brand profile
 */
export const brandsControllerDeleteBrandProfile = (
  orgId: string,
  clientId: string,
  id: string,
  options?: SecondParameter<typeof authFetch>
) => {
  return authFetch<DeleteBrandProfileResponseDto>(
    {
      url: `/api/v1/organizations/${orgId}/clients/${clientId}/brands/profiles/${id}`,
      method: 'DELETE',
    },
    options
  );
};

export const getBrandsControllerDeleteBrandProfileMutationOptions = <
  TError = void,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof brandsControllerDeleteBrandProfile>>,
    TError,
    { orgId: string; clientId: string; id: string },
    TContext
  >;
  request?: SecondParameter<typeof authFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof brandsControllerDeleteBrandProfile>>,
  TError,
  { orgId: string; clientId: string; id: string },
  TContext
> => {
  const mutationKey = ['brandsControllerDeleteBrandProfile'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof brandsControllerDeleteBrandProfile>>,
    { orgId: string; clientId: string; id: string }
  > = (props) => {
    const { orgId, clientId, id } = props ?? {};

    return brandsControllerDeleteBrandProfile(orgId, clientId, id, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type BrandsControllerDeleteBrandProfileMutationResult = NonNullable<
  Awaited<ReturnType<typeof brandsControllerDeleteBrandProfile>>
>;

export type BrandsControllerDeleteBrandProfileMutationError = void;

/**
 * @summary Delete brand profile
 */
export const useBrandsControllerDeleteBrandProfile = <TError = void, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof brandsControllerDeleteBrandProfile>>,
      TError,
      { orgId: string; clientId: string; id: string },
      TContext
    >;
    request?: SecondParameter<typeof authFetch>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof brandsControllerDeleteBrandProfile>>,
  TError,
  { orgId: string; clientId: string; id: string },
  TContext
> => {
  const mutationOptions = getBrandsControllerDeleteBrandProfileMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * Creates a new brand profile or updates existing one (one active profile per client)
 * @summary Create or update brand profile
 */
export const brandsControllerCreateBrandProfile = (
  orgId: string,
  clientId: string,
  createBrandProfileDto: CreateBrandProfileDto,
  options?: SecondParameter<typeof authFetch>,
  signal?: AbortSignal
) => {
  return authFetch<CreateBrandProfileResponseDto>(
    {
      url: `/api/v1/organizations/${orgId}/clients/${clientId}/brands/profiles`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: createBrandProfileDto,
      signal,
    },
    options
  );
};

export const getBrandsControllerCreateBrandProfileMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof brandsControllerCreateBrandProfile>>,
    TError,
    { orgId: string; clientId: string; data: CreateBrandProfileDto },
    TContext
  >;
  request?: SecondParameter<typeof authFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof brandsControllerCreateBrandProfile>>,
  TError,
  { orgId: string; clientId: string; data: CreateBrandProfileDto },
  TContext
> => {
  const mutationKey = ['brandsControllerCreateBrandProfile'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof brandsControllerCreateBrandProfile>>,
    { orgId: string; clientId: string; data: CreateBrandProfileDto }
  > = (props) => {
    const { orgId, clientId, data } = props ?? {};

    return brandsControllerCreateBrandProfile(orgId, clientId, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type BrandsControllerCreateBrandProfileMutationResult = NonNullable<
  Awaited<ReturnType<typeof brandsControllerCreateBrandProfile>>
>;
export type BrandsControllerCreateBrandProfileMutationBody = CreateBrandProfileDto;
export type BrandsControllerCreateBrandProfileMutationError = unknown;

/**
 * @summary Create or update brand profile
 */
export const useBrandsControllerCreateBrandProfile = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof brandsControllerCreateBrandProfile>>,
      TError,
      { orgId: string; clientId: string; data: CreateBrandProfileDto },
      TContext
    >;
    request?: SecondParameter<typeof authFetch>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof brandsControllerCreateBrandProfile>>,
  TError,
  { orgId: string; clientId: string; data: CreateBrandProfileDto },
  TContext
> => {
  const mutationOptions = getBrandsControllerCreateBrandProfileMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * Create a new color for a brand profile
 * @summary Add color to brand profile
 */
export const brandsControllerCreateBrandColor = (
  orgId: string,
  clientId: string,
  profileId: string,
  createBrandColorDto: CreateBrandColorDto,
  options?: SecondParameter<typeof authFetch>,
  signal?: AbortSignal
) => {
  return authFetch<CreateBrandColorResponseDto>(
    {
      url: `/api/v1/organizations/${orgId}/clients/${clientId}/brands/profiles/${profileId}/colors`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: createBrandColorDto,
      signal,
    },
    options
  );
};

export const getBrandsControllerCreateBrandColorMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof brandsControllerCreateBrandColor>>,
    TError,
    { orgId: string; clientId: string; profileId: string; data: CreateBrandColorDto },
    TContext
  >;
  request?: SecondParameter<typeof authFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof brandsControllerCreateBrandColor>>,
  TError,
  { orgId: string; clientId: string; profileId: string; data: CreateBrandColorDto },
  TContext
> => {
  const mutationKey = ['brandsControllerCreateBrandColor'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof brandsControllerCreateBrandColor>>,
    { orgId: string; clientId: string; profileId: string; data: CreateBrandColorDto }
  > = (props) => {
    const { orgId, clientId, profileId, data } = props ?? {};

    return brandsControllerCreateBrandColor(orgId, clientId, profileId, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type BrandsControllerCreateBrandColorMutationResult = NonNullable<
  Awaited<ReturnType<typeof brandsControllerCreateBrandColor>>
>;
export type BrandsControllerCreateBrandColorMutationBody = CreateBrandColorDto;
export type BrandsControllerCreateBrandColorMutationError = unknown;

/**
 * @summary Add color to brand profile
 */
export const useBrandsControllerCreateBrandColor = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof brandsControllerCreateBrandColor>>,
      TError,
      { orgId: string; clientId: string; profileId: string; data: CreateBrandColorDto },
      TContext
    >;
    request?: SecondParameter<typeof authFetch>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof brandsControllerCreateBrandColor>>,
  TError,
  { orgId: string; clientId: string; profileId: string; data: CreateBrandColorDto },
  TContext
> => {
  const mutationOptions = getBrandsControllerCreateBrandColorMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * Update an existing brand color
 * @summary Update brand color
 */
export const brandsControllerUpdateBrandColor = (
  orgId: string,
  clientId: string,
  profileId: string,
  colorId: string,
  updateBrandColorDto: UpdateBrandColorDto,
  options?: SecondParameter<typeof authFetch>
) => {
  return authFetch<UpdateBrandColorResponseDto>(
    {
      url: `/api/v1/organizations/${orgId}/clients/${clientId}/brands/profiles/${profileId}/colors/${colorId}`,
      method: 'PUT',
      headers: { 'Content-Type': 'application/json' },
      data: updateBrandColorDto,
    },
    options
  );
};

export const getBrandsControllerUpdateBrandColorMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof brandsControllerUpdateBrandColor>>,
    TError,
    {
      orgId: string;
      clientId: string;
      profileId: string;
      colorId: string;
      data: UpdateBrandColorDto;
    },
    TContext
  >;
  request?: SecondParameter<typeof authFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof brandsControllerUpdateBrandColor>>,
  TError,
  {
    orgId: string;
    clientId: string;
    profileId: string;
    colorId: string;
    data: UpdateBrandColorDto;
  },
  TContext
> => {
  const mutationKey = ['brandsControllerUpdateBrandColor'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof brandsControllerUpdateBrandColor>>,
    {
      orgId: string;
      clientId: string;
      profileId: string;
      colorId: string;
      data: UpdateBrandColorDto;
    }
  > = (props) => {
    const { orgId, clientId, profileId, colorId, data } = props ?? {};

    return brandsControllerUpdateBrandColor(
      orgId,
      clientId,
      profileId,
      colorId,
      data,
      requestOptions
    );
  };

  return { mutationFn, ...mutationOptions };
};

export type BrandsControllerUpdateBrandColorMutationResult = NonNullable<
  Awaited<ReturnType<typeof brandsControllerUpdateBrandColor>>
>;
export type BrandsControllerUpdateBrandColorMutationBody = UpdateBrandColorDto;
export type BrandsControllerUpdateBrandColorMutationError = unknown;

/**
 * @summary Update brand color
 */
export const useBrandsControllerUpdateBrandColor = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof brandsControllerUpdateBrandColor>>,
      TError,
      {
        orgId: string;
        clientId: string;
        profileId: string;
        colorId: string;
        data: UpdateBrandColorDto;
      },
      TContext
    >;
    request?: SecondParameter<typeof authFetch>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof brandsControllerUpdateBrandColor>>,
  TError,
  {
    orgId: string;
    clientId: string;
    profileId: string;
    colorId: string;
    data: UpdateBrandColorDto;
  },
  TContext
> => {
  const mutationOptions = getBrandsControllerUpdateBrandColorMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * Delete a brand color
 * @summary Delete brand color
 */
export const brandsControllerDeleteBrandColor = (
  orgId: string,
  clientId: string,
  profileId: string,
  colorId: string,
  options?: SecondParameter<typeof authFetch>
) => {
  return authFetch<DeleteBrandColorResponseDto>(
    {
      url: `/api/v1/organizations/${orgId}/clients/${clientId}/brands/profiles/${profileId}/colors/${colorId}`,
      method: 'DELETE',
    },
    options
  );
};

export const getBrandsControllerDeleteBrandColorMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof brandsControllerDeleteBrandColor>>,
    TError,
    { orgId: string; clientId: string; profileId: string; colorId: string },
    TContext
  >;
  request?: SecondParameter<typeof authFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof brandsControllerDeleteBrandColor>>,
  TError,
  { orgId: string; clientId: string; profileId: string; colorId: string },
  TContext
> => {
  const mutationKey = ['brandsControllerDeleteBrandColor'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof brandsControllerDeleteBrandColor>>,
    { orgId: string; clientId: string; profileId: string; colorId: string }
  > = (props) => {
    const { orgId, clientId, profileId, colorId } = props ?? {};

    return brandsControllerDeleteBrandColor(orgId, clientId, profileId, colorId, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type BrandsControllerDeleteBrandColorMutationResult = NonNullable<
  Awaited<ReturnType<typeof brandsControllerDeleteBrandColor>>
>;

export type BrandsControllerDeleteBrandColorMutationError = unknown;

/**
 * @summary Delete brand color
 */
export const useBrandsControllerDeleteBrandColor = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof brandsControllerDeleteBrandColor>>,
      TError,
      { orgId: string; clientId: string; profileId: string; colorId: string },
      TContext
    >;
    request?: SecondParameter<typeof authFetch>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof brandsControllerDeleteBrandColor>>,
  TError,
  { orgId: string; clientId: string; profileId: string; colorId: string },
  TContext
> => {
  const mutationOptions = getBrandsControllerDeleteBrandColorMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * Create a new font for a brand profile. Supports Google Fonts via URL or any font family name.
 * @summary Add font to brand profile
 */
export const brandsControllerCreateBrandFont = (
  orgId: string,
  clientId: string,
  profileId: string,
  createBrandFontDto: CreateBrandFontDto,
  options?: SecondParameter<typeof authFetch>,
  signal?: AbortSignal
) => {
  return authFetch<CreateBrandFontResponseDto>(
    {
      url: `/api/v1/organizations/${orgId}/clients/${clientId}/brands/profiles/${profileId}/fonts`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: createBrandFontDto,
      signal,
    },
    options
  );
};

export const getBrandsControllerCreateBrandFontMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof brandsControllerCreateBrandFont>>,
    TError,
    { orgId: string; clientId: string; profileId: string; data: CreateBrandFontDto },
    TContext
  >;
  request?: SecondParameter<typeof authFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof brandsControllerCreateBrandFont>>,
  TError,
  { orgId: string; clientId: string; profileId: string; data: CreateBrandFontDto },
  TContext
> => {
  const mutationKey = ['brandsControllerCreateBrandFont'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof brandsControllerCreateBrandFont>>,
    { orgId: string; clientId: string; profileId: string; data: CreateBrandFontDto }
  > = (props) => {
    const { orgId, clientId, profileId, data } = props ?? {};

    return brandsControllerCreateBrandFont(orgId, clientId, profileId, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type BrandsControllerCreateBrandFontMutationResult = NonNullable<
  Awaited<ReturnType<typeof brandsControllerCreateBrandFont>>
>;
export type BrandsControllerCreateBrandFontMutationBody = CreateBrandFontDto;
export type BrandsControllerCreateBrandFontMutationError = unknown;

/**
 * @summary Add font to brand profile
 */
export const useBrandsControllerCreateBrandFont = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof brandsControllerCreateBrandFont>>,
      TError,
      { orgId: string; clientId: string; profileId: string; data: CreateBrandFontDto },
      TContext
    >;
    request?: SecondParameter<typeof authFetch>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof brandsControllerCreateBrandFont>>,
  TError,
  { orgId: string; clientId: string; profileId: string; data: CreateBrandFontDto },
  TContext
> => {
  const mutationOptions = getBrandsControllerCreateBrandFontMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * Upload a .woff2, .ttf, or .otf font file to S3 and create a brand font record.
 * @summary Upload a custom font file
 */
export const brandsControllerUploadBrandFont = (
  orgId: string,
  clientId: string,
  profileId: string,
  brandsControllerUploadBrandFontBody: BrandsControllerUploadBrandFontBody,
  options?: SecondParameter<typeof authFetch>,
  signal?: AbortSignal
) => {
  const formData = new FormData();
  formData.append(`file`, brandsControllerUploadBrandFontBody.file);
  formData.append(`fontFamily`, brandsControllerUploadBrandFontBody.fontFamily);
  formData.append(`usage`, brandsControllerUploadBrandFontBody.usage);
  if (brandsControllerUploadBrandFontBody.fontWeight !== undefined) {
    formData.append(`fontWeight`, brandsControllerUploadBrandFontBody.fontWeight);
  }
  if (brandsControllerUploadBrandFontBody.isPrimary !== undefined) {
    formData.append(`isPrimary`, brandsControllerUploadBrandFontBody.isPrimary.toString());
  }

  return authFetch<CreateBrandFontResponseDto>(
    {
      url: `/api/v1/organizations/${orgId}/clients/${clientId}/brands/profiles/${profileId}/fonts/upload`,
      method: 'POST',
      headers: { 'Content-Type': 'multipart/form-data' },
      data: formData,
      signal,
    },
    options
  );
};

export const getBrandsControllerUploadBrandFontMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof brandsControllerUploadBrandFont>>,
    TError,
    {
      orgId: string;
      clientId: string;
      profileId: string;
      data: BrandsControllerUploadBrandFontBody;
    },
    TContext
  >;
  request?: SecondParameter<typeof authFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof brandsControllerUploadBrandFont>>,
  TError,
  { orgId: string; clientId: string; profileId: string; data: BrandsControllerUploadBrandFontBody },
  TContext
> => {
  const mutationKey = ['brandsControllerUploadBrandFont'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof brandsControllerUploadBrandFont>>,
    {
      orgId: string;
      clientId: string;
      profileId: string;
      data: BrandsControllerUploadBrandFontBody;
    }
  > = (props) => {
    const { orgId, clientId, profileId, data } = props ?? {};

    return brandsControllerUploadBrandFont(orgId, clientId, profileId, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type BrandsControllerUploadBrandFontMutationResult = NonNullable<
  Awaited<ReturnType<typeof brandsControllerUploadBrandFont>>
>;
export type BrandsControllerUploadBrandFontMutationBody = BrandsControllerUploadBrandFontBody;
export type BrandsControllerUploadBrandFontMutationError = unknown;

/**
 * @summary Upload a custom font file
 */
export const useBrandsControllerUploadBrandFont = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof brandsControllerUploadBrandFont>>,
      TError,
      {
        orgId: string;
        clientId: string;
        profileId: string;
        data: BrandsControllerUploadBrandFontBody;
      },
      TContext
    >;
    request?: SecondParameter<typeof authFetch>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof brandsControllerUploadBrandFont>>,
  TError,
  { orgId: string; clientId: string; profileId: string; data: BrandsControllerUploadBrandFontBody },
  TContext
> => {
  const mutationOptions = getBrandsControllerUploadBrandFontMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * Update an existing brand font
 * @summary Update brand font
 */
export const brandsControllerUpdateBrandFont = (
  orgId: string,
  clientId: string,
  profileId: string,
  fontId: string,
  updateBrandFontDto: UpdateBrandFontDto,
  options?: SecondParameter<typeof authFetch>
) => {
  return authFetch<UpdateBrandFontResponseDto>(
    {
      url: `/api/v1/organizations/${orgId}/clients/${clientId}/brands/profiles/${profileId}/fonts/${fontId}`,
      method: 'PUT',
      headers: { 'Content-Type': 'application/json' },
      data: updateBrandFontDto,
    },
    options
  );
};

export const getBrandsControllerUpdateBrandFontMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof brandsControllerUpdateBrandFont>>,
    TError,
    {
      orgId: string;
      clientId: string;
      profileId: string;
      fontId: string;
      data: UpdateBrandFontDto;
    },
    TContext
  >;
  request?: SecondParameter<typeof authFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof brandsControllerUpdateBrandFont>>,
  TError,
  { orgId: string; clientId: string; profileId: string; fontId: string; data: UpdateBrandFontDto },
  TContext
> => {
  const mutationKey = ['brandsControllerUpdateBrandFont'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof brandsControllerUpdateBrandFont>>,
    { orgId: string; clientId: string; profileId: string; fontId: string; data: UpdateBrandFontDto }
  > = (props) => {
    const { orgId, clientId, profileId, fontId, data } = props ?? {};

    return brandsControllerUpdateBrandFont(
      orgId,
      clientId,
      profileId,
      fontId,
      data,
      requestOptions
    );
  };

  return { mutationFn, ...mutationOptions };
};

export type BrandsControllerUpdateBrandFontMutationResult = NonNullable<
  Awaited<ReturnType<typeof brandsControllerUpdateBrandFont>>
>;
export type BrandsControllerUpdateBrandFontMutationBody = UpdateBrandFontDto;
export type BrandsControllerUpdateBrandFontMutationError = unknown;

/**
 * @summary Update brand font
 */
export const useBrandsControllerUpdateBrandFont = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof brandsControllerUpdateBrandFont>>,
      TError,
      {
        orgId: string;
        clientId: string;
        profileId: string;
        fontId: string;
        data: UpdateBrandFontDto;
      },
      TContext
    >;
    request?: SecondParameter<typeof authFetch>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof brandsControllerUpdateBrandFont>>,
  TError,
  { orgId: string; clientId: string; profileId: string; fontId: string; data: UpdateBrandFontDto },
  TContext
> => {
  const mutationOptions = getBrandsControllerUpdateBrandFontMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * Delete a brand font
 * @summary Delete brand font
 */
export const brandsControllerDeleteBrandFont = (
  orgId: string,
  clientId: string,
  profileId: string,
  fontId: string,
  options?: SecondParameter<typeof authFetch>
) => {
  return authFetch<DeleteBrandFontResponseDto>(
    {
      url: `/api/v1/organizations/${orgId}/clients/${clientId}/brands/profiles/${profileId}/fonts/${fontId}`,
      method: 'DELETE',
    },
    options
  );
};

export const getBrandsControllerDeleteBrandFontMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof brandsControllerDeleteBrandFont>>,
    TError,
    { orgId: string; clientId: string; profileId: string; fontId: string },
    TContext
  >;
  request?: SecondParameter<typeof authFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof brandsControllerDeleteBrandFont>>,
  TError,
  { orgId: string; clientId: string; profileId: string; fontId: string },
  TContext
> => {
  const mutationKey = ['brandsControllerDeleteBrandFont'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof brandsControllerDeleteBrandFont>>,
    { orgId: string; clientId: string; profileId: string; fontId: string }
  > = (props) => {
    const { orgId, clientId, profileId, fontId } = props ?? {};

    return brandsControllerDeleteBrandFont(orgId, clientId, profileId, fontId, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type BrandsControllerDeleteBrandFontMutationResult = NonNullable<
  Awaited<ReturnType<typeof brandsControllerDeleteBrandFont>>
>;

export type BrandsControllerDeleteBrandFontMutationError = unknown;

/**
 * @summary Delete brand font
 */
export const useBrandsControllerDeleteBrandFont = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof brandsControllerDeleteBrandFont>>,
      TError,
      { orgId: string; clientId: string; profileId: string; fontId: string },
      TContext
    >;
    request?: SecondParameter<typeof authFetch>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof brandsControllerDeleteBrandFont>>,
  TError,
  { orgId: string; clientId: string; profileId: string; fontId: string },
  TContext
> => {
  const mutationOptions = getBrandsControllerDeleteBrandFontMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary Add nav link to brand profile
 */
export const brandsControllerCreateBrandNavLink = (
  orgId: string,
  clientId: string,
  profileId: string,
  createBrandNavLinkDto: CreateBrandNavLinkDto,
  options?: SecondParameter<typeof authFetch>,
  signal?: AbortSignal
) => {
  return authFetch<CreateBrandNavLinkResponseDto>(
    {
      url: `/api/v1/organizations/${orgId}/clients/${clientId}/brands/profiles/${profileId}/nav-links`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: createBrandNavLinkDto,
      signal,
    },
    options
  );
};

export const getBrandsControllerCreateBrandNavLinkMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof brandsControllerCreateBrandNavLink>>,
    TError,
    { orgId: string; clientId: string; profileId: string; data: CreateBrandNavLinkDto },
    TContext
  >;
  request?: SecondParameter<typeof authFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof brandsControllerCreateBrandNavLink>>,
  TError,
  { orgId: string; clientId: string; profileId: string; data: CreateBrandNavLinkDto },
  TContext
> => {
  const mutationKey = ['brandsControllerCreateBrandNavLink'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof brandsControllerCreateBrandNavLink>>,
    { orgId: string; clientId: string; profileId: string; data: CreateBrandNavLinkDto }
  > = (props) => {
    const { orgId, clientId, profileId, data } = props ?? {};

    return brandsControllerCreateBrandNavLink(orgId, clientId, profileId, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type BrandsControllerCreateBrandNavLinkMutationResult = NonNullable<
  Awaited<ReturnType<typeof brandsControllerCreateBrandNavLink>>
>;
export type BrandsControllerCreateBrandNavLinkMutationBody = CreateBrandNavLinkDto;
export type BrandsControllerCreateBrandNavLinkMutationError = unknown;

/**
 * @summary Add nav link to brand profile
 */
export const useBrandsControllerCreateBrandNavLink = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof brandsControllerCreateBrandNavLink>>,
      TError,
      { orgId: string; clientId: string; profileId: string; data: CreateBrandNavLinkDto },
      TContext
    >;
    request?: SecondParameter<typeof authFetch>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof brandsControllerCreateBrandNavLink>>,
  TError,
  { orgId: string; clientId: string; profileId: string; data: CreateBrandNavLinkDto },
  TContext
> => {
  const mutationOptions = getBrandsControllerCreateBrandNavLinkMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary Update brand nav link
 */
export const brandsControllerUpdateBrandNavLink = (
  orgId: string,
  clientId: string,
  profileId: string,
  linkId: string,
  updateBrandNavLinkDto: UpdateBrandNavLinkDto,
  options?: SecondParameter<typeof authFetch>
) => {
  return authFetch<UpdateBrandNavLinkResponseDto>(
    {
      url: `/api/v1/organizations/${orgId}/clients/${clientId}/brands/profiles/${profileId}/nav-links/${linkId}`,
      method: 'PUT',
      headers: { 'Content-Type': 'application/json' },
      data: updateBrandNavLinkDto,
    },
    options
  );
};

export const getBrandsControllerUpdateBrandNavLinkMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof brandsControllerUpdateBrandNavLink>>,
    TError,
    {
      orgId: string;
      clientId: string;
      profileId: string;
      linkId: string;
      data: UpdateBrandNavLinkDto;
    },
    TContext
  >;
  request?: SecondParameter<typeof authFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof brandsControllerUpdateBrandNavLink>>,
  TError,
  {
    orgId: string;
    clientId: string;
    profileId: string;
    linkId: string;
    data: UpdateBrandNavLinkDto;
  },
  TContext
> => {
  const mutationKey = ['brandsControllerUpdateBrandNavLink'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof brandsControllerUpdateBrandNavLink>>,
    {
      orgId: string;
      clientId: string;
      profileId: string;
      linkId: string;
      data: UpdateBrandNavLinkDto;
    }
  > = (props) => {
    const { orgId, clientId, profileId, linkId, data } = props ?? {};

    return brandsControllerUpdateBrandNavLink(
      orgId,
      clientId,
      profileId,
      linkId,
      data,
      requestOptions
    );
  };

  return { mutationFn, ...mutationOptions };
};

export type BrandsControllerUpdateBrandNavLinkMutationResult = NonNullable<
  Awaited<ReturnType<typeof brandsControllerUpdateBrandNavLink>>
>;
export type BrandsControllerUpdateBrandNavLinkMutationBody = UpdateBrandNavLinkDto;
export type BrandsControllerUpdateBrandNavLinkMutationError = unknown;

/**
 * @summary Update brand nav link
 */
export const useBrandsControllerUpdateBrandNavLink = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof brandsControllerUpdateBrandNavLink>>,
      TError,
      {
        orgId: string;
        clientId: string;
        profileId: string;
        linkId: string;
        data: UpdateBrandNavLinkDto;
      },
      TContext
    >;
    request?: SecondParameter<typeof authFetch>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof brandsControllerUpdateBrandNavLink>>,
  TError,
  {
    orgId: string;
    clientId: string;
    profileId: string;
    linkId: string;
    data: UpdateBrandNavLinkDto;
  },
  TContext
> => {
  const mutationOptions = getBrandsControllerUpdateBrandNavLinkMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary Delete brand nav link
 */
export const brandsControllerDeleteBrandNavLink = (
  orgId: string,
  clientId: string,
  profileId: string,
  linkId: string,
  options?: SecondParameter<typeof authFetch>
) => {
  return authFetch<DeleteBrandNavLinkResponseDto>(
    {
      url: `/api/v1/organizations/${orgId}/clients/${clientId}/brands/profiles/${profileId}/nav-links/${linkId}`,
      method: 'DELETE',
    },
    options
  );
};

export const getBrandsControllerDeleteBrandNavLinkMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof brandsControllerDeleteBrandNavLink>>,
    TError,
    { orgId: string; clientId: string; profileId: string; linkId: string },
    TContext
  >;
  request?: SecondParameter<typeof authFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof brandsControllerDeleteBrandNavLink>>,
  TError,
  { orgId: string; clientId: string; profileId: string; linkId: string },
  TContext
> => {
  const mutationKey = ['brandsControllerDeleteBrandNavLink'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof brandsControllerDeleteBrandNavLink>>,
    { orgId: string; clientId: string; profileId: string; linkId: string }
  > = (props) => {
    const { orgId, clientId, profileId, linkId } = props ?? {};

    return brandsControllerDeleteBrandNavLink(orgId, clientId, profileId, linkId, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type BrandsControllerDeleteBrandNavLinkMutationResult = NonNullable<
  Awaited<ReturnType<typeof brandsControllerDeleteBrandNavLink>>
>;

export type BrandsControllerDeleteBrandNavLinkMutationError = unknown;

/**
 * @summary Delete brand nav link
 */
export const useBrandsControllerDeleteBrandNavLink = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof brandsControllerDeleteBrandNavLink>>,
      TError,
      { orgId: string; clientId: string; profileId: string; linkId: string },
      TContext
    >;
    request?: SecondParameter<typeof authFetch>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof brandsControllerDeleteBrandNavLink>>,
  TError,
  { orgId: string; clientId: string; profileId: string; linkId: string },
  TContext
> => {
  const mutationOptions = getBrandsControllerDeleteBrandNavLinkMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * Scrapes each URL on its own — no link following — and adds what it finds to the brand: page imagery into a new media collection, and optionally the products the page sells into the catalog. Purely additive: brand colors, fonts, logo, nav and voice are never modified. Re-submitting a URL that is already pending or running returns the existing import instead of queueing a duplicate.
 * @summary Queue one or more pages to scrape into this brand
 */
export const brandsControllerCreatePageImports = (
  orgId: string,
  clientId: string,
  profileId: string,
  createPageImportsDto: CreatePageImportsDto,
  options?: SecondParameter<typeof authFetch>,
  signal?: AbortSignal
) => {
  return authFetch<CreatePageImportsResponseDto>(
    {
      url: `/api/v1/organizations/${orgId}/clients/${clientId}/brands/profiles/${profileId}/page-imports`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: createPageImportsDto,
      signal,
    },
    options
  );
};

export const getBrandsControllerCreatePageImportsMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof brandsControllerCreatePageImports>>,
    TError,
    { orgId: string; clientId: string; profileId: string; data: CreatePageImportsDto },
    TContext
  >;
  request?: SecondParameter<typeof authFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof brandsControllerCreatePageImports>>,
  TError,
  { orgId: string; clientId: string; profileId: string; data: CreatePageImportsDto },
  TContext
> => {
  const mutationKey = ['brandsControllerCreatePageImports'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof brandsControllerCreatePageImports>>,
    { orgId: string; clientId: string; profileId: string; data: CreatePageImportsDto }
  > = (props) => {
    const { orgId, clientId, profileId, data } = props ?? {};

    return brandsControllerCreatePageImports(orgId, clientId, profileId, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type BrandsControllerCreatePageImportsMutationResult = NonNullable<
  Awaited<ReturnType<typeof brandsControllerCreatePageImports>>
>;
export type BrandsControllerCreatePageImportsMutationBody = CreatePageImportsDto;
export type BrandsControllerCreatePageImportsMutationError = unknown;

/**
 * @summary Queue one or more pages to scrape into this brand
 */
export const useBrandsControllerCreatePageImports = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof brandsControllerCreatePageImports>>,
      TError,
      { orgId: string; clientId: string; profileId: string; data: CreatePageImportsDto },
      TContext
    >;
    request?: SecondParameter<typeof authFetch>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof brandsControllerCreatePageImports>>,
  TError,
  { orgId: string; clientId: string; profileId: string; data: CreatePageImportsDto },
  TContext
> => {
  const mutationOptions = getBrandsControllerCreatePageImportsMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * Newest first. Poll this while any row is pending or in_progress to track scrape results.
 * @summary List page imports for this brand
 */
export const brandsControllerListPageImports = (
  orgId: string,
  clientId: string,
  profileId: string,
  options?: SecondParameter<typeof authFetch>,
  signal?: AbortSignal
) => {
  return authFetch<PageImportListResponseDto>(
    {
      url: `/api/v1/organizations/${orgId}/clients/${clientId}/brands/profiles/${profileId}/page-imports`,
      method: 'GET',
      signal,
    },
    options
  );
};

export const getBrandsControllerListPageImportsQueryKey = (
  orgId?: string,
  clientId?: string,
  profileId?: string
) => {
  return [
    `/api/v1/organizations/${orgId}/clients/${clientId}/brands/profiles/${profileId}/page-imports`,
  ] as const;
};

export const getBrandsControllerListPageImportsQueryOptions = <
  TData = Awaited<ReturnType<typeof brandsControllerListPageImports>>,
  TError = unknown,
>(
  orgId: string,
  clientId: string,
  profileId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof brandsControllerListPageImports>>, TError, TData>
    >;
    request?: SecondParameter<typeof authFetch>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getBrandsControllerListPageImportsQueryKey(orgId, clientId, profileId);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof brandsControllerListPageImports>>> = ({
    signal,
  }) => brandsControllerListPageImports(orgId, clientId, profileId, requestOptions, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!(orgId && clientId && profileId),
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof brandsControllerListPageImports>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type BrandsControllerListPageImportsQueryResult = NonNullable<
  Awaited<ReturnType<typeof brandsControllerListPageImports>>
>;
export type BrandsControllerListPageImportsQueryError = unknown;

export function useBrandsControllerListPageImports<
  TData = Awaited<ReturnType<typeof brandsControllerListPageImports>>,
  TError = unknown,
>(
  orgId: string,
  clientId: string,
  profileId: string,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof brandsControllerListPageImports>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof brandsControllerListPageImports>>,
          TError,
          Awaited<ReturnType<typeof brandsControllerListPageImports>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof authFetch>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useBrandsControllerListPageImports<
  TData = Awaited<ReturnType<typeof brandsControllerListPageImports>>,
  TError = unknown,
>(
  orgId: string,
  clientId: string,
  profileId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof brandsControllerListPageImports>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof brandsControllerListPageImports>>,
          TError,
          Awaited<ReturnType<typeof brandsControllerListPageImports>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof authFetch>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useBrandsControllerListPageImports<
  TData = Awaited<ReturnType<typeof brandsControllerListPageImports>>,
  TError = unknown,
>(
  orgId: string,
  clientId: string,
  profileId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof brandsControllerListPageImports>>, TError, TData>
    >;
    request?: SecondParameter<typeof authFetch>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary List page imports for this brand
 */

export function useBrandsControllerListPageImports<
  TData = Awaited<ReturnType<typeof brandsControllerListPageImports>>,
  TError = unknown,
>(
  orgId: string,
  clientId: string,
  profileId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof brandsControllerListPageImports>>, TError, TData>
    >;
    request?: SecondParameter<typeof authFetch>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getBrandsControllerListPageImportsQueryOptions(
    orgId,
    clientId,
    profileId,
    options
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Deletes the import record only. Imagery and products it already added stay in the media library and catalog — remove those there if they are unwanted.
 * @summary Remove a page import record
 */
export const brandsControllerDeletePageImport = (
  orgId: string,
  clientId: string,
  profileId: string,
  importId: string,
  options?: SecondParameter<typeof authFetch>
) => {
  return authFetch<DeletePageImportResponseDto>(
    {
      url: `/api/v1/organizations/${orgId}/clients/${clientId}/brands/profiles/${profileId}/page-imports/${importId}`,
      method: 'DELETE',
    },
    options
  );
};

export const getBrandsControllerDeletePageImportMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof brandsControllerDeletePageImport>>,
    TError,
    { orgId: string; clientId: string; profileId: string; importId: string },
    TContext
  >;
  request?: SecondParameter<typeof authFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof brandsControllerDeletePageImport>>,
  TError,
  { orgId: string; clientId: string; profileId: string; importId: string },
  TContext
> => {
  const mutationKey = ['brandsControllerDeletePageImport'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof brandsControllerDeletePageImport>>,
    { orgId: string; clientId: string; profileId: string; importId: string }
  > = (props) => {
    const { orgId, clientId, profileId, importId } = props ?? {};

    return brandsControllerDeletePageImport(orgId, clientId, profileId, importId, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type BrandsControllerDeletePageImportMutationResult = NonNullable<
  Awaited<ReturnType<typeof brandsControllerDeletePageImport>>
>;

export type BrandsControllerDeletePageImportMutationError = unknown;

/**
 * @summary Remove a page import record
 */
export const useBrandsControllerDeletePageImport = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof brandsControllerDeletePageImport>>,
      TError,
      { orgId: string; clientId: string; profileId: string; importId: string },
      TContext
    >;
    request?: SecondParameter<typeof authFetch>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof brandsControllerDeletePageImport>>,
  TError,
  { orgId: string; clientId: string; profileId: string; importId: string },
  TContext
> => {
  const mutationOptions = getBrandsControllerDeletePageImportMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * Subscribes to the Redis channel where the brand-extraction worker publishes stage_start / stage_progress / stage_done / complete / error events. The stream closes on `complete` or `error`, or after a 5-minute timeout.
 * @summary SSE stream of brand extraction progress events
 */
export const brandsControllerStreamExtractionProgress = (
  orgId: string,
  clientId: string,
  profileId: string,
  options?: SecondParameter<typeof authFetch>,
  signal?: AbortSignal
) => {
  return authFetch<BrandExtractionStreamEventDto>(
    {
      url: `/api/v1/organizations/${orgId}/clients/${clientId}/brands/profiles/${profileId}/extraction/stream`,
      method: 'GET',
      signal,
    },
    options
  );
};

export const getBrandsControllerStreamExtractionProgressQueryKey = (
  orgId?: string,
  clientId?: string,
  profileId?: string
) => {
  return [
    `/api/v1/organizations/${orgId}/clients/${clientId}/brands/profiles/${profileId}/extraction/stream`,
  ] as const;
};

export const getBrandsControllerStreamExtractionProgressQueryOptions = <
  TData = Awaited<ReturnType<typeof brandsControllerStreamExtractionProgress>>,
  TError = unknown,
>(
  orgId: string,
  clientId: string,
  profileId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof brandsControllerStreamExtractionProgress>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof authFetch>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getBrandsControllerStreamExtractionProgressQueryKey(orgId, clientId, profileId);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof brandsControllerStreamExtractionProgress>>
  > = ({ signal }) =>
    brandsControllerStreamExtractionProgress(orgId, clientId, profileId, requestOptions, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!(orgId && clientId && profileId),
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof brandsControllerStreamExtractionProgress>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type BrandsControllerStreamExtractionProgressQueryResult = NonNullable<
  Awaited<ReturnType<typeof brandsControllerStreamExtractionProgress>>
>;
export type BrandsControllerStreamExtractionProgressQueryError = unknown;

export function useBrandsControllerStreamExtractionProgress<
  TData = Awaited<ReturnType<typeof brandsControllerStreamExtractionProgress>>,
  TError = unknown,
>(
  orgId: string,
  clientId: string,
  profileId: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof brandsControllerStreamExtractionProgress>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof brandsControllerStreamExtractionProgress>>,
          TError,
          Awaited<ReturnType<typeof brandsControllerStreamExtractionProgress>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof authFetch>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useBrandsControllerStreamExtractionProgress<
  TData = Awaited<ReturnType<typeof brandsControllerStreamExtractionProgress>>,
  TError = unknown,
>(
  orgId: string,
  clientId: string,
  profileId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof brandsControllerStreamExtractionProgress>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof brandsControllerStreamExtractionProgress>>,
          TError,
          Awaited<ReturnType<typeof brandsControllerStreamExtractionProgress>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof authFetch>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useBrandsControllerStreamExtractionProgress<
  TData = Awaited<ReturnType<typeof brandsControllerStreamExtractionProgress>>,
  TError = unknown,
>(
  orgId: string,
  clientId: string,
  profileId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof brandsControllerStreamExtractionProgress>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof authFetch>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary SSE stream of brand extraction progress events
 */

export function useBrandsControllerStreamExtractionProgress<
  TData = Awaited<ReturnType<typeof brandsControllerStreamExtractionProgress>>,
  TError = unknown,
>(
  orgId: string,
  clientId: string,
  profileId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof brandsControllerStreamExtractionProgress>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof authFetch>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getBrandsControllerStreamExtractionProgressQueryOptions(
    orgId,
    clientId,
    profileId,
    options
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Approve the extracted brand profile
 */
export const brandsControllerApproveBrandReview = (
  orgId: string,
  clientId: string,
  profileId: string,
  options?: SecondParameter<typeof authFetch>,
  signal?: AbortSignal
) => {
  return authFetch<BrandReviewResponseDto>(
    {
      url: `/api/v1/organizations/${orgId}/clients/${clientId}/brands/profiles/${profileId}/review/approve`,
      method: 'POST',
      signal,
    },
    options
  );
};

export const getBrandsControllerApproveBrandReviewMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof brandsControllerApproveBrandReview>>,
    TError,
    { orgId: string; clientId: string; profileId: string },
    TContext
  >;
  request?: SecondParameter<typeof authFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof brandsControllerApproveBrandReview>>,
  TError,
  { orgId: string; clientId: string; profileId: string },
  TContext
> => {
  const mutationKey = ['brandsControllerApproveBrandReview'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof brandsControllerApproveBrandReview>>,
    { orgId: string; clientId: string; profileId: string }
  > = (props) => {
    const { orgId, clientId, profileId } = props ?? {};

    return brandsControllerApproveBrandReview(orgId, clientId, profileId, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type BrandsControllerApproveBrandReviewMutationResult = NonNullable<
  Awaited<ReturnType<typeof brandsControllerApproveBrandReview>>
>;

export type BrandsControllerApproveBrandReviewMutationError = unknown;

/**
 * @summary Approve the extracted brand profile
 */
export const useBrandsControllerApproveBrandReview = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof brandsControllerApproveBrandReview>>,
      TError,
      { orgId: string; clientId: string; profileId: string },
      TContext
    >;
    request?: SecondParameter<typeof authFetch>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof brandsControllerApproveBrandReview>>,
  TError,
  { orgId: string; clientId: string; profileId: string },
  TContext
> => {
  const mutationOptions = getBrandsControllerApproveBrandReviewMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary Dismiss the review prompt without approving (remind me later)
 */
export const brandsControllerDismissBrandReview = (
  orgId: string,
  clientId: string,
  profileId: string,
  options?: SecondParameter<typeof authFetch>,
  signal?: AbortSignal
) => {
  return authFetch<BrandReviewResponseDto>(
    {
      url: `/api/v1/organizations/${orgId}/clients/${clientId}/brands/profiles/${profileId}/review/dismiss`,
      method: 'POST',
      signal,
    },
    options
  );
};

export const getBrandsControllerDismissBrandReviewMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof brandsControllerDismissBrandReview>>,
    TError,
    { orgId: string; clientId: string; profileId: string },
    TContext
  >;
  request?: SecondParameter<typeof authFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof brandsControllerDismissBrandReview>>,
  TError,
  { orgId: string; clientId: string; profileId: string },
  TContext
> => {
  const mutationKey = ['brandsControllerDismissBrandReview'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof brandsControllerDismissBrandReview>>,
    { orgId: string; clientId: string; profileId: string }
  > = (props) => {
    const { orgId, clientId, profileId } = props ?? {};

    return brandsControllerDismissBrandReview(orgId, clientId, profileId, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type BrandsControllerDismissBrandReviewMutationResult = NonNullable<
  Awaited<ReturnType<typeof brandsControllerDismissBrandReview>>
>;

export type BrandsControllerDismissBrandReviewMutationError = unknown;

/**
 * @summary Dismiss the review prompt without approving (remind me later)
 */
export const useBrandsControllerDismissBrandReview = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof brandsControllerDismissBrandReview>>,
      TError,
      { orgId: string; clientId: string; profileId: string },
      TContext
    >;
    request?: SecondParameter<typeof authFetch>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof brandsControllerDismissBrandReview>>,
  TError,
  { orgId: string; clientId: string; profileId: string },
  TContext
> => {
  const mutationOptions = getBrandsControllerDismissBrandReviewMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary Reorder brand nav links
 */
export const brandsControllerReorderBrandNavLinks = (
  orgId: string,
  clientId: string,
  profileId: string,
  reorderBrandNavLinksDto: ReorderBrandNavLinksDto,
  options?: SecondParameter<typeof authFetch>
) => {
  return authFetch<ReorderBrandNavLinksResponseDto>(
    {
      url: `/api/v1/organizations/${orgId}/clients/${clientId}/brands/profiles/${profileId}/nav-links-reorder`,
      method: 'PUT',
      headers: { 'Content-Type': 'application/json' },
      data: reorderBrandNavLinksDto,
    },
    options
  );
};

export const getBrandsControllerReorderBrandNavLinksMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof brandsControllerReorderBrandNavLinks>>,
    TError,
    { orgId: string; clientId: string; profileId: string; data: ReorderBrandNavLinksDto },
    TContext
  >;
  request?: SecondParameter<typeof authFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof brandsControllerReorderBrandNavLinks>>,
  TError,
  { orgId: string; clientId: string; profileId: string; data: ReorderBrandNavLinksDto },
  TContext
> => {
  const mutationKey = ['brandsControllerReorderBrandNavLinks'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof brandsControllerReorderBrandNavLinks>>,
    { orgId: string; clientId: string; profileId: string; data: ReorderBrandNavLinksDto }
  > = (props) => {
    const { orgId, clientId, profileId, data } = props ?? {};

    return brandsControllerReorderBrandNavLinks(orgId, clientId, profileId, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type BrandsControllerReorderBrandNavLinksMutationResult = NonNullable<
  Awaited<ReturnType<typeof brandsControllerReorderBrandNavLinks>>
>;
export type BrandsControllerReorderBrandNavLinksMutationBody = ReorderBrandNavLinksDto;
export type BrandsControllerReorderBrandNavLinksMutationError = unknown;

/**
 * @summary Reorder brand nav links
 */
export const useBrandsControllerReorderBrandNavLinks = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof brandsControllerReorderBrandNavLinks>>,
      TError,
      { orgId: string; clientId: string; profileId: string; data: ReorderBrandNavLinksDto },
      TContext
    >;
    request?: SecondParameter<typeof authFetch>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof brandsControllerReorderBrandNavLinks>>,
  TError,
  { orgId: string; clientId: string; profileId: string; data: ReorderBrandNavLinksDto },
  TContext
> => {
  const mutationOptions = getBrandsControllerReorderBrandNavLinksMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
